import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendGetRequest } from '../../../api/requestUtil';

export const fetchBlogFragment = createAsyncThunk(
  'fragment/fetchBlog',
  async (blogId: number) => sendGetRequest(`/api/terrain/fragment/blog/${blogId}/`)
);

export const fetchListFragment = createAsyncThunk(
  'fragment/fetchList',
  async (listId: number) => sendGetRequest(`/api/terrain/fragment/list/${listId}/`)
);
